const HtmlTagName = Object.freeze({
    EMAIL : "email",
    PASSWORD : "password",
    CONFIRMPASSWORD : "confirmPassword",
    TEXT : "text",
    NAME : "name",
    DESCRIPTION : "description",
    LOGIN : "login",
    REGISTRATION: "registration",
    ROLE : "role",
    POLICY: "policy",
    USER: "user",
    FIRSTNAME:"firstName",
    MIDDLENAME: "middleName",
    LASTNAME: "lastName",
    USERNAME : "username"

});

export default HtmlTagName;